export const AUTH_ROUTES = {
	AUTH: "/auth",
} as const;
